// extracted by mini-css-extract-plugin
export default {"tasksContent":"styles_tasksContent__mvdmW","loader":"styles_loader__TYYIK","taskPageWrapper":"styles_taskPageWrapper__BbJnl"};